import React from 'react';
import { Tooltip } from '@mui/material';

//shared tooltip component
const SocialTooltip = ({ children, title }) => {
  return (
    <Tooltip
      classes={{
        tooltip: 'game-tooltip',
        arrow: 'game-tooltip-arrow',
      }}
      className=""
      arrow
      placement="top"
      title={title}
    >
      {children}
    </Tooltip>
  );
};
export default SocialTooltip;
